import { growChevronIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const ExpandAlt = createIcon({
  displayName: 'ExpandAlt',
  paths: [
    'M597.333 128c0 23.552 19.115 42.667 42.667 42.667h152.943l-218.453 218.492c-16.683 16.683-16.683 43.691 0 60.373 16.64 16.64 43.691 16.64 60.331 0l218.513-218.513v152.981c0 23.552 19.115 42.667 42.667 42.667s42.667-19.115 42.667-42.667v-256c0-23.552-19.115-42.667-42.667-42.667h-256c-23.552 0-42.667 19.115-42.667 42.667zM231.057 853.333h152.943c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667h-256c-23.552 0-42.667-19.115-42.667-42.667v-256c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667v152.981l218.513-218.513c16.64-16.64 43.691-16.64 60.331 0 16.683 16.683 16.683 43.691 0 60.373l-218.453 218.492z'
  ],
  canvasPaths: canvasIconPaths(growChevronIcon)
})
